/* unplugin-vue-components disabled */import { render } from "./share-modal.vue?vue&type=template&id=143a388c&scoped=true"
import script from "./share-modal.vue?vue&type=script&lang=js"
export * from "./share-modal.vue?vue&type=script&lang=js"

import "./share-modal.vue?vue&type=style&index=0&id=143a388c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143a388c"],['__file',"src/pages/share-chat/share-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "143a388c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('143a388c', __exports__)) {
    api.reload('143a388c', __exports__)
  }
  
  module.hot.accept("./share-modal.vue?vue&type=template&id=143a388c&scoped=true", () => {
    api.rerender('143a388c', render)
  })

}


export default __exports__